import {format} from "date-fns";
import { de } from 'date-fns/locale';
import {IClient, IClientSickLeave, IEmployeeSickLeave} from "../../utils/FrontendDataTypes";

interface SickLeaveWarning {
    from: Date,
    path: string,
    header: string,
    text: string,
    buttonText: string,
    variant: string,
    key: string
}

export default (employeeSickLeave: IEmployeeSickLeave[], clientSickLeave: IClientSickLeave[], client: IClient[]) : SickLeaveWarning[] => {

    const employee = employeeSickLeave
        .map((esl) => {

            const formattedDate = format(esl.from, 'dd.MM.y', { locale: de });

            let obj = {
                from: esl.from,
                path: `/sick-leave/edit/employee/${esl.record_id}`,
                header: "Mitarbeiter AU-Meldung abschließen",
                text: `Schließe hier deine AU-Meldung vom ${formattedDate} ab.`,
                buttonText: "AU Abschließen",
                variant: 'warning',
                key: `warning_employee_sick_leave_${esl.record_id}`
            };

            // Child of employee
            if (esl.reason === 2) {
                obj.header = "Kind AU-Meldung abschließen";
                obj.text = "Schließe hier die AU-Meldung deines Kindes vom "+formattedDate+" ab.";
                obj.buttonText = "AU Abschließen";
            }

            return obj;

        })

    const clients = clientSickLeave
        .map((csl) => {
            const formattedDate = format(new Date(csl.from), 'dd.MM.y', { locale: de });

            let variant = 'light';
            if (!csl.to || new Date(csl.to) <= new Date()) {
                variant = 'warning';
            }

            const fetchedClient = client.find((c) => c.record_id === csl.client)

            const key = `warning_client_sick_leave_${csl.record_id}`

            if (csl.to) {
                return {
                    from: csl.from,
                    path: `/sick-leave/edit/client/${csl.record_id}`,
                    header: "Klienten Krankmeldung abschließen",
                    text: `Schließe die Krankmeldung des Klienten ${fetchedClient?.first_name} ${fetchedClient?.last_name} vom "${formattedDate}" ab, sobald er wieder da ist.`,
                    buttonText: "Krankmeldung abschließen",
                    variant: variant,
                    key: key,
                }
            }
            return {
                from: csl.from,
                path: `/sick-leave/edit/client/${csl.record_id}`,
                header: "Klienten Krankmeldung vervollständigen",
                text: `Trage das "Krank bis"-Datum für den Klienten ${fetchedClient?.first_name} ${fetchedClient?.last_name} vom "${formattedDate}" in der Klienten Krankmeldung ein.`,
                buttonText: "Krankmeldung vervollständigen",
                variant: variant,
                key: key,
            }

        })

    return [
        ... employee,
        ... clients
    ]

}